module.exports = __webpack_public_path__ + "static/media/d1860261-0230-4f42-98db-053577250511-b4FUsIwNTu793EtUQ0XGiBPhs3nO2f.fe561392.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/d1860261-0230-4f42-98db-053577250511-b4FUsIwNTu793EtUQ0XGiBPhs3nO2f.webp
// module id = 634
// module chunks = 0